import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import useConstrainable from "../hooks/use-constrainable";
import useWillClearConstrainOnUnmount from "../hooks/use-will-clear-constrain-on-unmount";

function StaticFilter(props) {

    useWillClearConstrainOnUnmount(props.name);

    const constrainable = useConstrainable();

    React.useEffect(() => {
        constrainable.setConstraint(props.name, props.value);
    });

    return null;
}

StaticFilter.defaultProps = {
    value: null
};

StaticFilter.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
};

export default observer(StaticFilter);
